import { useTranslation } from 'react-i18next';

export default function LeadFollowUpHeader({
  propertyType,
  section,
  location,
}: {
  propertyType: string;
  section: string;
  location: string;
}) {
  const { t } = useTranslation('app');
  const interpolation = { propertyType, section, location };

  return (
    <div className="flex flex-col items-center gap-x text-center md:gap-1.5x">
      <h1 className="text-title-2 text-black md:text-title-1">
        {t('leadFollowUpTitle', interpolation)}
      </h1>
      <p className="max-w-[720px] text-body-2 text-gray__dark_1">
        {t('leadFollowUpDescription', interpolation)}
      </p>
    </div>
  );
}
